import { useRef } from "react";
import classNames from "classnames";
import { Callout } from "@/shared/ui/ancestry";
import styles from "./RangeSlider.module.scss";

interface ZoomButtonProps {
    direction: "left" | "right";
    label: string;
    disabled?: boolean;
    onClick: () => void;
    className?: string;
}

export function ZoomButton({ direction, label, disabled, onClick, className }: ZoomButtonProps) {
    const triggerRef = useRef<HTMLButtonElement>(null);
    const iconClass = direction === "left" ? "iconArrowLeft" : "iconArrowRight";

    return (
        <>
            <button
                ref={triggerRef}
                type="button"
                className={classNames("bgDark ancBtn ancBtnIconOnly icon", iconClass, styles.zoomBtn, className)}
                aria-label={label}
                disabled={disabled}
                onClick={onClick}
            />
            <Callout position="top" trigger={triggerRef} type="hover">
                {label}
            </Callout>
        </>
    );
}
